import { render, staticRenderFns } from "./identityInformation.vue?vue&type=template&id=6c26785c&scoped=true&"
import script from "./identityInformation.vue?vue&type=script&lang=js&"
export * from "./identityInformation.vue?vue&type=script&lang=js&"
import style0 from "./identityInformation.vue?vue&type=style&index=0&id=6c26785c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26785c",
  null
  
)

export default component.exports